// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'

import unitsOccupancyReducer from './unitsOccupancyReducer'

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  unitsOccupancyReducer
})

export default rootReducer
